<template>
  <div class="login-container">
    <div>
      <video
        class="display-video"
        muted
        type="video/webm"
        src="../../assets/video/video.mp4"
        autoplay
        loop
      ></video>
    </div>

    <div
      class="login_form"
      :style="{ position: 'fixed', top: '0px', left: '0px' }"
    >
      <div class="form_content">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          auto-complete="on"
          label-position="left"
        >
          <!-- <div class="title-container">
            <h3 class="title">{{ companyTitle }}</h3>
          </div> -->
          <div class="logo-container">
            <img src="../../assets/image/sr-power.png" alt="Sr-Power Logo" class="logo-image">
          </div>
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="请输入手机号"
              type="text"
            >
              <svg-icon slot="prefix" icon-class="user" />
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              @input="(e) => (loginForm.password = $replaceSymbols(e))"
            >
              <svg-icon slot="prefix" icon-class="pwd" />
            </el-input>
          </el-form-item>
          <!-- <nocaptcha lang="cn" :appkey="'FFFF0N00000000009B13'" :scene="`nc_login`" @callback="getToken" /> -->
          <el-form-item>
            <!-- <no-captcha @handleSlideAly="getToken" :loading="loading" /> -->
          </el-form-item>
          <el-form-item class="tal">
            <el-checkbox v-model="remember"
              ><span style="color: #ffffff">记住手机号</span></el-checkbox
            >
            <span class="fr">
              <el-button type="text" @click="forgetPwd()">
                <span style="color: #ffffff; text-decoration: underline"
                  >忘记密码</span
                >
              </el-button>
            </span>
          </el-form-item>

          <el-button
            :loading="loading"
            type="primary"
            style="width: 100%; margin-bottom: 30px"
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
        </el-form>
      </div>
    </div>
    <div class="footer">
      <div class="footer-content">
        <!-- 公安备案 -->
        <div class="footer-item">
          <img 
            src="../../assets/image/filing_icon.png" 
            alt="公安备案图标" 
            class="security-record-image"
            loading="lazy"
          >
          <a 
            href="https://beian.mps.gov.cn/#/query/webSearch?code=32021402003918" 
            rel="noopener noreferrer" 
            target="_blank" 
            class="footer-link"
          >
            苏公网安备32021402003918号
          </a>
        </div>
        
        <span class="footer-separator">|</span>
        
        <!-- ICP备案 -->
        <div class="footer-item">
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer"
            class="footer-link"
          >
            苏ICP备2021024718号-1
          </a>
        </div>
        
        <span class="footer-separator">|</span>
        
        <!-- 认证信息 -->
        <div class="footer-item">
          <span class="footer-cert">已通过ISO/IEC 27001:2022认证</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { nocaptcha } from 'vue-nocaptcha'
import { getCode } from "@/api/userApi";
import { regexs } from "@/utils/validate";
import { removeToken } from "@/utils/auth";
import NoCaptcha from "@/components/NoCaptcha/index";
import { login } from "@/api/authApi";
import { getParameterByName } from "@/utils/index";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: regexs.mobile,
            message: "请输入正确的手机号",
            trigger: "submit",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: regexs.pwd,
            message: "请输入8~15位字母和数字组成的密码",
            trigger: "submit",
          },
        ],
      },
      loading: false,
      redirect: undefined,
      isVerification: true,
      remember: false,
     
    };
  },
  created() {
    const username = window.localStorage.getItem("userName");
    removeToken();
    if (username != null) {
      this.remember = true;
      this.loginForm.username = username;
    }
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
    //this.companyTitle = window.location.href.includes("customer")
    //  ? "奥立信工业互联网平台"
    //  : "爱景工业互联网平台";
    //  console.log('111');
      
  },
  components: {
  
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode === 13) {
        this.handleLogin();
      }
    },
    handleLogin() {
      //   this.$router.push({name: 'HomePage'})
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          if (!this.isVerification) {
            this.$message.warning("请先滑动验证");
            return false;
          } else {
            this.loading = true;
            if (this.remember) {
              window.localStorage.setItem("userName", this.loginForm.username);
            } else {
              window.localStorage.removeItem("userName");
            }

            try {
              //service
              let service = getParameterByName("service");

              const { username, password } = this.loginForm;

              //17602526128
              //aaa123456

              //请求服务器
              const ticket = await login(username, password, service);

              //ticket
              console.log(ticket, "ticket");

              //重定向
              window.location.href = service + "&ticket=" + ticket;

              // await this.$store.dispatch("user/login", this.loginForm);
              // this.$router.push({ name: "Entry" });
              // window.localStorage.setItem("projectId", "");

              this.loading = false;
            } catch {
              this.loading = false;
              this.isVerification = true;
              // location.reload()
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      // });
    // },
    // getToken(val) {
    //   let params = {
    //     sessionId: val.sessionId,
    //     scene: val.scene,
    //     sig: val.sig,
    //     token: val.token,
    //   };
    //   getCode(params)
    //     .then(() => {
    //       this.isVerification = true;
    //     })
    //     .catch(() => {
          // this.loading = false;
          //this.isVerification = false;
          // this.isVerification = true;
          // location.reload()
        });
    },
    forgetPwd() {
      //service
      let service = getParameterByName("service");
      if (service) {
        // console.log(service,'service............');
        this.$router.push({
          path: "/forgetPwd",
          query: {
            service: service,
          },
        });
      } else {
        this.$router.push({
          path: "/forgetPwd",
        });
      }
    },
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>


<style lang="scss">
.nc-container {
  #nc_1_wrapper {
    width: 100% !important;
  }
}
.nc-container .nc_scale span {
  height: 34px !important;
}
</style>

<style lang="scss">
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.display-video {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.login-container {
  min-height: 100%;
  width: 100%;
  //background: url('../../assets/image/login_bg.png') no-repeat center center;
  background-image: linear-gradient(to bottom right, #0e1a36, #172649);
  background-size: 100% 100%;
  max-height: 100%;
  overflow: hidden;
  & > .login_form {
    width: 100%;
    min-height: 937px;
    text-align: right;
    padding-right: 130px;
    overflow-y: auto;
    .form_content {
      margin: 50px;
      margin-top: 200px;
      width: 400px;
      padding: 50px;
      display: inline-block;
      background: rgba(71, 106, 153, 0.24);
      border-radius: 5px;
      .el-form-item__content {
        .el-input__inner {
          background: #0e162b !important;
          border: 1px solid #1a2950 !important;
          color: #ffffff !important;
        }
        .el-input__prefix {
          left: 10px;
        }
      }
    }
  }

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }
  .el-checkbox__label {
    font-size: 12px !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #088eff !important;
    border-color: #088eff !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #088eff !important;
  }
  .tips {
    font-size: 14px;

    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  // .title-container {
  //   position: relative;

  //   .title {
  //     font-size: 26px;
  //     color: $light_gray;
  //     margin: 0px auto 40px auto;
  //     text-align: center;
  //     font-weight: bold;
  //   }
  // }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .logo-image {
    width: 180px; // 根据实际需求调整宽度
    height: auto; // 保持图片比例
    display: block;
    margin: 0 auto; // 居中显示
  }
  .logo-container {
    text-align: center;
    margin-bottom: 20px;
  }
  .footer {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    z-index: 1000;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    
    &-content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 12px 16px;
    }
    
    &-item {
      display: inline-flex;
      align-items: center;
      gap: 8px; // 图标和文字间距
    }
    
    &-link {
      color: rgba(255, 255, 255, 0.9);
      text-decoration: none;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.4;
      transition: all 0.3s ease;
      text-shadow: 
        0 1px 3px rgba(0, 0, 0, 0.8),
        0 0 10px rgba(0, 0, 0, 0.4);
      
      &:hover {
        color: #ffffff;
        text-decoration: underline;
        text-underline-offset: 2px;
        text-shadow: 
          0 1px 4px rgba(0, 0, 0, 0.9),
          0 0 15px rgba(255, 255, 255, 0.2);
      }
    }
    
    &-cert {
      color: rgba(255, 255, 255, 0.85);
      font-size: 13px;
      font-weight: 400;
      line-height: 1.4;
      text-shadow: 
        0 1px 3px rgba(0, 0, 0, 0.8),
        0 0 10px rgba(0, 0, 0, 0.4);
    }
    
    &-separator {
      color: rgba(255, 255, 255, 0.4);
      font-size: 12px;
      user-select: none;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
    }
  }

  .security-record-image {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
    filter: 
      brightness(1.4) 
      drop-shadow(0 1px 3px rgba(0, 0, 0, 0.7))
      contrast(1.1);
    opacity: 0.95;
    transition: all 0.3s ease;
    
    &:hover {
      filter: 
        brightness(1.6)
        drop-shadow(0 1px 4px rgba(0, 0, 0, 0.8))
        contrast(1.2);
      opacity: 1;
    }
  }

  // 可选：添加微弱的发光动画效果
  @keyframes text-glow {
    0%, 100% {
      text-shadow: 
        0 1px 3px rgba(0, 0, 0, 0.8),
        0 0 10px rgba(0, 0, 0, 0.4);
    }
    50% {
      text-shadow: 
        0 1px 4px rgba(0, 0, 0, 0.9),
        0 0 12px rgba(0, 0, 0, 0.5);
    }
  }

  .footer-link,
  .footer-cert {
    animation: text-glow 6s ease-in-out infinite;
  }

  // 确保在复杂背景上的可读性增强
  .footer-item {
    position: relative;
    
    // 为文字添加微弱的背景光晕（深色背景上更清晰）
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -4px;
      right: -4px;
      bottom: -2px;
      background: linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.1) 50%,
        rgba(0, 0, 0, 0.3) 100%
      );
      border-radius: 3px;
      z-index: -1;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    &:hover::before {
      opacity: 0.6;
    }
  }

  .footer-link,
  .footer-cert {
    position: relative;
    z-index: 1;
  }
}
</style>
